export default __webpack_public_path__ + "static/media/zoldfutar_gomb.0b1527c5.png";